// src/utils/sanityClient.js
import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

// Create the client configuration using your actual project details
const client = createClient({
  projectId: 'rbjyn1y6',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2023-05-03',
});

// Set up the image URL builder
const builder = imageUrlBuilder(client);

// Export the urlFor function for generating image URLs
export const urlFor = (source) => {
  if (!source) {
    console.warn('No image source provided to urlFor');
    return {
      url: () => null
    };
  }
  return builder.image(source);
};

// Export the client as default for general use
export default client;